<template>
    <div>
        <swb-query-sort-area :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" ref="query_model_ctrl" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        <div v-if="params.showDefServicer == true && params.showContractServicer == true" class="tab-container small base mt10">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-if="params.showDefServicer == true" :class="{'current': tabClickValue == 'def_servicer'}" class="head-item" @click="handleTabClick('def_servicer')">
                        <span>特定可用资产</span>
                    </li>
                    <li v-if="params.showContractServicer == true" :class="{'current': tabClickValue == 'contract_servicer'}" class="head-item" @click="handleTabClick('contract_servicer')">
                        <span>合同可用资产</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mt10">
            <swb-result-table :confKey="confKey" :onConfigReady="onTableConfigReady" :configAuto="true" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :height="500" ref="result_table" :needPager="true" :rowNoShow="true" :rowNoFixed="true" :rowNoAsSeqNo="true" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import appConf from '../../app.conf';
    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../app.conf'
    import { openShopDeviceSuitSelectDlg } from './selectDlg'
    import { openBizDepartDlg, openComStaffComnSelectDlg } from '../orgStruct/selectDlg'
    import {
        loadAssetKindList,
        loadShopWarehouseList,
        loadRetailerDevcGroupList,
        loadRetailerShopTagList,
        loadAcctEnterWayList
    } from '../retailer/asset-comn'
    //
    import shopDevcApi from '../../api/shopDevc'
    import shopStockApi from '../../api/shopStock'
    import userApi from '../../api/user'
    import assetApi from '../../api/asset'
    import retailerApi from '../../api/retailer'
    import SwbResultTable from '../query/ResultTable'
    Vue.regist(SwbResultTable);
    //
    import SwbShopDeviceSvcSubNoListForSelect from '../retailer/ShopDeviceSvcSubNoListForSelect'
    Vue.regist(SwbShopDeviceSvcSubNoListForSelect);

    export default {
        desc: '门店资产服务子号选择列表',// 用于选择门店设备服务子号
        path: '',
        name: 'swb-shop-device-svc-sub-no-list-for-select',
        notAsResc: true,
        authen: false,
        avlScopes: 'retailer',
        props: {
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            multiSelect: {
                type: Boolean,
                default: false
            },
            initChecked: {
                type: Object,
                default: null
            },
            params: {
                type: Object,
                default: function () {
                    return {showDefServicer: true, showContractServicer: true};
                }
            }
        },
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                shopDeviceSubNoList: [],
                //
                normalValue: null,
                devcClearCauseMap: null,
                seprPeriodStateMap: null,
                acctEnterWayMap: null,
                inactiveValue: null,
                startValue: null,
                clearValue: null,
                outageValue: null,
                currentComId: null,
                lockIdMap: {},

                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                metaColList: [],
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                //
                globalLoading: MsgBox.loading(),
                queryOnLoad: true,
                confKey: "device-for-select-list-single-none",
                tabClickValue: null
            }
        },
        created: function () {
            let self = this;
            // 需要的信息
            let multiSelect = self.multiSelect == null ? true : self.multiSelect;
            if(multiSelect) {
                this.multiSelect = true;
                this.multiPageSelect = true;
            } else {
                this.multiSelect = false;
                this.multiPageSelect = false;
            }
            //
            if(this.params.showDefServicer == true && this.params.showContractServicer == true) {
                this.tabClickValue = 'def_servicer';
            }
            // 需要的信息
            this.pageSize = this.pageSizes.first();
            //
            this.normalValue = getEnumInfoWith('deviceState', 'name', 'Normal').value;
            this.startValue = getEnumInfoWith('deviceUseState', 'name', 'Start').value;
            this.outageValue = getEnumInfoWith('deviceUseState', 'name', 'Outage').value;
            this.inactiveValue = getEnumInfoWith('deviceUseState', 'name', 'Inactive').value;
            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            this.devcClearCauseMap = getEnumMap("devcClearCause", "value2text");
            this.seprPeriodStateMap = getEnumMap("seprPeriodState", "value2text");
            this.lockIdMap = getEnumMap("devcVoucherType", "value2text");
            //
            let queryModel = self.queryModel;
            queryModel.filterItems = this.filter;
            //
            this.getCurrentUserInfo();
        },
        watch: {},
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass("overFlow-hidden");
            this.initResultTable();
            this.handleInitChecked(this.initChecked);
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            handleTabClick(val) {
                if(this.tabClickValue != val) {
                    this.tabClickValue = val;
                    //
                    this.pageNumber = 1;
                    this.getShopDeviceSvcSubNoByComId();
                }
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                this.getShopDeviceSvcSubNoByComId();
            },
            onConfigReady: function () {
                this.initAsyncQueryModel();
            },
            onTableConfigReady: function () {
                this.globalLoading.hide();
            },
            initAsyncQueryModel() {
                let self = this;
                loadAssetKindList(function (dataList) {
                    self.updateQueryModelField("assetKindId", dataList);
                });
                //
                loadAcctEnterWayList(function (dataList) {
                    self.updateQueryModelField("acctEnterWay", dataList);
                });
                // 分类分组
                let devcGroupId = this.filter.devcGroupId;
                if(devcGroupId != null) {
                    self.updateQueryModelHiddenField("devcGroupId", true);
                } else {
                    loadRetailerDevcGroupList(function (dataList) {
                        self.updateQueryModelField("devcGroupId", dataList);
                    });
                }
                //
                let comId = this.filter.retailerComId;
//                // 加载仓库 - 无仓库过滤
//                loadShopWarehouseList(comId, function (dataList) {
//                    self.updateQueryModelField("warehouseId", dataList);
//                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelHiddenField: function (itemCode, hiddenValue) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {hidden: hiddenValue};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
//                resultTable.setColConfRef(this.querySortArea);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'lockBizType': function (row, colName, colValue, rowIndex, colConf) {
                        if(self.lockIdMap[row.id] != null) {
                            return '<span class="font-red" >' + self.lockIdMap[row.id] + '</span>';
                        }
                    },
                    'locked': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span >否</span>';
                        }
                    },
                    'statusLabel': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if(row.wrntDueTime != null && new Date(row.currentTime).getTime() > new Date(row.wrntDueTime).getTime()) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保外</a>';
                        }
                        if(row.wrntDueTime == null || new Date(row.currentTime).getTime() <= new Date(row.wrntDueTime).getTime()) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保内</a>';
                        }
                        if(row.tagMissing != null && row.tagMissing) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">缺码</a>';
                        }
                        if(row.inStock) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">在库</a>';
                        }
                        if(row.inUse) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">在用</a>';
                        }
                        return domHtml;
                    },
                    'inStock': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return '<span class="font-green" >是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'indoubtFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue == 1) {
                            return '<span class="font-red" >是</span>';
                        }
                    },
                    'suitMainFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.suitId != null) {
                            if(colValue) {
                                return ' <span class="font-green">是</span>';
                            } else {
                                return '<span >否</span>';
                            }
                        } else {
                            return "";
                        }
                    },
                    'imported': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span >否</span>';
                        }
                    },
                    'specialFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span >否</span>';
                        }
                    },
                    'inUse': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'useState': function (row, colName, colValue, rowIndex, colConf) {
                        if(!row.started && row.useState == self.inactiveValue && row.state == 0) {
                            return ' <span class="font-black">未启用</span>';
                        } else if(row.useState == self.outageValue) {
                            return '<span class="font-gold">已停用</span>';
                        } else if(row.useState == self.startValue) {
                            return '<span class="font-green">已启用</span>'
                        }
                    },
                    'state': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue == 0) {
                            return '<span class="font-green" >正常</span>';
                        } else if(colValue == 1) {
                            return '<span class="font-red" >故障未报修</span>';
                        } else if(colValue == 2) {
                            return '<span class="font-black" >故障已报修</span>';
                        } else if(colValue == 3) {
                            return '<span class="font-black" >故障维修中</span>';
                        }
                    },
                    'scrapped': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'outageTimeMi': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null) {
                            return '<span>' + colValue + '</span>';
                        } else {
                            return '<span>0</span>';
                        }
                    },
                    'rented': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'fiscalAcctFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'acctEnterWay': function (row, colName, colValue, rowIndex, colConf) {
                        let acctEnterWay = self.acctEnterWayMap[colValue];
                        if(acctEnterWay != null) {
                            return '<span>' + acctEnterWay + '</span>';
                        }
                    },
                    'rmnWorthRatio': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue == null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'orgWorth': function (row, colName, colValue, rowIndex, colConf) {

                        if(colValue == null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'netWorth': function (row, colName, colValue, rowIndex, colConf) {

                        if(colValue == null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'deprPeriod': function (row, colName, colValue, rowIndex, colConf) {
                        let deprPeriod = self.seprPeriodStateMap[colValue];
                        if(deprPeriod != null) {
                            return '<span>' + deprPeriod + '</span>';
                        }
                    },
                    'devcDefFlagName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.devcDefId == -1) {
                            return '<span>未关联</span>';
                        } else {
                            return '<span>已关联</span>';
                        }
                    },
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult() {
                let selection = this.getTableSelection();
                let result = {};
                if(selection == null) {
                    result.type = 'warn';
                    result.message = "请选择！";
                } else {
                    result.type = 'info';
                    result.data = selection;
                }
                return result;
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        self.currentComId = scopeEntity.comId;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            // 分页切换
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getShopDeviceSvcSubNoByComId();
            },
            getShopDeviceSvcSubNoByComId: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                filterItems = Utils.merge(filterItems, self.filter);
                filterItems.lowCostFlag = false;
                let suitIds = filterItems.suitIds;
                if(!Utils.isNoB(suitIds)) {
                    filterItems.suitIdList = suitIds.split("_");
                }
                //
                if(this.tabClickValue != null) {
                    filterItems.selectType = this.tabClickValue;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                shopDevcApi.getSelectShopDeviceSvcSubNoListByFilter(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let data = result.data;
                        let shopDeviceSubNoList = data.rows || [];
                        self.shopDeviceSubNoList = Utils.merge([], shopDeviceSubNoList);
                        self.totalCount = result.data.pagination.totalCount;
                        //
                        self.renderTable(shopDeviceSubNoList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 渲染数据
            renderTable(rows, pagination) {
                //let resultColConfCmp = this.$refs['result_col_conf'];
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                // let confColList = resultColConfCmp.getMetaColList();
                //resultTable.initMeta(confColList);
                let dataMap = {
                    pagination: pagination,
                    rows: rows
                };
                //设置新数据
                resultTable.render(dataMap);
            },
            //回显数据处理
            handleInitChecked(initChecked) {
                let resultTable = this.$refs.result_table;
                resultTable.setInitChecked(initChecked, true);
            },
            popupHandler: function (fieldCode, curValue, curText) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let filter = this.filterItem;
                if(fieldCode == 'departId') {
                    openBizDepartDlg(filter.selectComId, function (bizDepart) {
                        let fieldInfo = {
                            departId: {
                                value: bizDepart.id,
                                text: bizDepart.name
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                } else if(fieldCode == 'usagedDepartId') {
                    openBizDepartDlg(filter.selectComId, function (bizDepart) {
                        let fieldInfo = {
                            usagedDepartId: {
                                value: bizDepart.id,
                                text: bizDepart.name
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceSvcSubNoListForSelect.vue